export default __webpack_public_path__ + "5b8b95a6eb365554a7c1763dff999b65.png";